import ErrorAlert from "@/utility/ErrorAlert";
import http from "@/axios/http-common";
import {
  BedManagementChecklist,
  BedManagementListFilter,
  BedManagementPayload
} from "@/types/bedManagement";

async function masters() {
  const response = await http.getData("/bed-management/masters").catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function list(params: BedManagementListFilter = {}) {
  const response = await http
    .getDataParam("/bed-management", { params })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function find(id: number) {
  const response = await http.getData(`/bed-management/${id}`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function create(data: BedManagementPayload) {
  const response = await http.postData("/bed-management", data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function update(id: number, data: BedManagementPayload) {
  const response = await http
    .putData(`/bed-management/${id}`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function updateEvaluasi(id: number, evaluasi: BedManagementChecklist) {
  const response = await http
    .putData(`/bed-management/${id}/evaluasi`, { evaluasi })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function destroy(id: number) {
  const response = await http.deleteData(`/bed-management/${id}`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

function printPdf(id: number) {
  window.open(`${http.getAPI()}/bed-management/${id}/pdf`, "_blank");
}

interface GalatBerkas {
  response?: { data?: unknown };
}

async function laporkanGalatBlob(err: GalatBerkas) {
  const isi = err?.response?.data;

  if (err.response && isi instanceof Blob) {
    try {
      err.response.data = JSON.parse(await isi.text());
    } catch {
      // 
    }
  }

  ErrorAlert.showErrorAlert(err);
}

async function rekapFilterOptions() {
  const response = await http
    .getData("/bed-management/rekap/filter-options")
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function downloadExcel(params: BedManagementListFilter) {
  const sufiks =
    params.mode === "rentang"
      ? [params.tanggal_dari, params.tanggal_sampai].filter(Boolean).join("_")
      : params.periode || "";

  const res = await http
    .getDataParam("/bed-management/rekap/excel", { params, responseType: "blob" })
    .catch(async err => {
      await laporkanGalatBlob(err);
      return Promise.reject(err);
    });

  const url = URL.createObjectURL(
    new Blob([res.data], {
      type:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    })
  );
  const a = document.createElement("a");
  a.href = url;
  a.download = sufiks
    ? `rekap-bed-management_${sufiks}.xlsx`
    : "rekap-bed-management.xlsx";
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 60000);
}

export default {
  masters,
  list,
  find,
  create,
  update,
  updateEvaluasi,
  destroy,
  printPdf,
  rekapFilterOptions,
  downloadExcel
};
